import React, { useState, useEffect, useRef } from "react";
import Header from "../../component/menu/Header";
import { constants } from "../../constant/constants";
import SideMenu from "../../component/menu/SideMenu";
import ItemWiseSalesReportComponent from "../../component/restaurants/reports/ItemWiseSalesReportComponent";
import { ReportService } from "../../services/reports-services";
import useUserStore from "../../stores/store";
import CustomLoader from "../../component/menu/CustomLoader";

export default function ItemWiseSalesReport() {
  const { user, restaurantId, showNotification, networkCall, setNetworkCall } = useUserStore();
  const [itemWiseSalesReports, setItemWiseSalesReports] = useState(null);
  const [itemWiseSalesCategories, setItemWiseSalesCategories] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalItem, setTotalItem] = useState(0);
  const [itemWiseSalesFilter, setItemWiseSalesFilter] = useState({
    restaurantId: restaurantId,
    fromDate: "",
    toDate: "",
    categoryId: "",
    sortBy: "",
  });
  const [isFilterClear, setIsFilterClear] = useState(false);
  const isFetching = useRef(false);

  async function fetchItemWiseSalesReportList(filter) {
    setNetworkCall(true);
    try {
      const itemWiseSalesList = await ReportService.getItemWiseSalesReportList(
        filter,
        user.token.token
      );
      setItemWiseSalesReports(itemWiseSalesList.data);
      setPage(itemWiseSalesList.page);
      setPerPage(itemWiseSalesList.perPage);
      setTotalItem(itemWiseSalesList.total);
      setNetworkCall(false);
      return itemWiseSalesList.data;
    } catch (err) {
      console.error(err);
      showNotification("Something went wrong. Try again later.");
      setNetworkCall(false);
      return;
    }
  }

  async function fetchCategories() {
    const params = { restaurantId: restaurantId };
    const categories = await ReportService.getReportCategories(
      params,
      user.token.token
    );
    setItemWiseSalesCategories(categories);
  }

  /** init */
  useEffect(() => {
    async function fetchData() {
      if (restaurantId) {
        await fetchCategories();
      }
    }
    fetchData();
  }, [restaurantId]);

  useEffect(() => {
    async function fetchData() {
      if (isFetching.current) return;
      isFetching.current = true;

      try {
        const tempFilter = { ...itemWiseSalesFilter, page, perPage };
        await fetchItemWiseSalesReportList(tempFilter);
      } catch (err) {
        console.error("Error fetching:", err);
      } finally {
        isFetching.current = false;
      }
    }

    fetchData();
  }, [page, perPage]);

  useEffect(() => {
    async function fetchData() {
      if (isFilterClear) {
        await fetchItemWiseSalesReportList(itemWiseSalesFilter);
        setIsFilterClear(false);
      }
    }

    fetchData();
  }, [isFilterClear]);

  function onHandleFilterData() {
    if (page !== 1 || perPage !== 10) {
      setPage(1);
      setPerPage(10);
    }
    const tempFilter = { ...itemWiseSalesFilter, page: 1, perPage: 10 };
    fetchItemWiseSalesReportList(tempFilter);
  }

  function onHandlePageChange(page, pageSize) {
    setPage(page);
    setPerPage(pageSize);
  }

  function onHandlePageSizeChange(current, size) {
    setPerPage(size);
  }

  function onHandleDownloadReport() {
    const {page, perPage, ...params} = itemWiseSalesFilter;
    setNetworkCall(true);
    ReportService.getDownloadItemWiseSalesReport(params, user.token.token).then(
      (res) => {
        if (res.data) {
          setNetworkCall(false);
          ReportService.downloadPDF(res.data, "item-wise-sales-report.pdf");
          showNotification('Itemwise sales report downloaded successfully!', false);
        } else {
          setNetworkCall(false);
          showNotification("Failed to download the report");
          return;
        }
      }
    );
  }

  return (
    <section>
      <div className="flex flex-col">
        <CustomLoader />
        <Header title={""} menu={constants.MENU.SALES_REPORT} currentMenuKey={'T_6_S_6_L_2'}/>
        <div className="flex flex-row bg-prewhite px-[12%]">
          <SideMenu title={`Sale Report`} menu={constants.MENU.SALES_REPORT} />
        </div>
        <div className=" mt-[80px] ml-[80px] px-[50px]">
          <h1 className="pt-[50px] pb-[20px] font-bold text-black text-[24px] leading-[24px] cursor-default">
            {constants.MENU.REPORTS[2]}
          </h1>

          <ItemWiseSalesReportComponent
            reportData={itemWiseSalesReports}
            categories={itemWiseSalesCategories}
            setItemWiseSalesFilter={setItemWiseSalesFilter}
            handleFilterApply={onHandleFilterData}
            handlePageChange={onHandlePageChange}
            handlePageSizeChange={onHandlePageSizeChange}
            page={page}
            perPage={perPage}
            setPerPage={setPerPage}
            total={totalItem}
            setIsFilterClear={setIsFilterClear}
            handleDownload={onHandleDownloadReport}
            loading={networkCall}
          />
        </div>
      </div>
    </section>
  );
}
